import { render, staticRenderFns } from "./TrainingMaterials.vue?vue&type=template&id=1c0d9fbc"
import script from "../../scripts/pages/TrainingMaterials.js?vue&type=script&lang=js&external"
export * from "../../scripts/pages/TrainingMaterials.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports